import { Palette } from '@mui/material/styles';

/**
 * This style makes a child SVG be a lighter gray when not hovered.
 *
 * When hovered, the SVG's default font color will show
 *
 * @returns class to be passed to any parent with an SVG Icon child. Usually `IconButton` or `Button`
 */
export const useSubtleIcon = (palette: Palette) => {
  return {
    subtleIcon: {
      '&:not(:hover)': {
        '& svg': {
          color: palette.text.secondary,
        },
      },
    },
  };
};

export const useSuccessIcon = (palette: Palette) => {
  return {
    successIcon: {
      color: getSuccessIconColor(palette),
    },
  };
};

export const useWarningIcon = (palette: Palette) => {
  return {
    warningIcon: {
      color: getWarningIconColor(palette),
    },
  };
};

export const useErrorIcon = (palette: Palette) => {
  return {
    errorIcon: {
      color: getErrorIconColor(palette),
    },
  };
};

export const useNoDataIcon = (palette: Palette) => {
  return {
    noDataIcon: {
      color: getNoDataIconColor(palette),
    },
  };
};

export const useDisabledIcon = (palette: Palette) => {
  return {
    disabledIcon: {
      color: getDisabledIconColor(palette),
    },
  };
};

export const getDisabledIconColor = (palette: Palette) => {
  return palette.secondary.dark;
};

export const getErrorIconColor = (palette: Palette) => {
  return palette.error.main;
};

export const getNoDataIconColor = (palette: Palette) => {
  return palette.error.light;
};

export const getSuccessIconColor = (palette: Palette) => {
  return palette.success.main;
};

export const getWarningIconColor = (palette: Palette) => {
  return palette.warning.dark;
};
